import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import App from './App';

const HOME_ROUTE = '/';
const PRERENDER_ROUTE_ATTRIBUTE = 'data-prerender-route';

function readBrowserPathname() {
  if (typeof window === 'undefined') {
    return null;
  }

  return window.location.pathname;
}

function shouldHydratePrerenderedRoot(rootElement, pathname = readBrowserPathname()) {
  return Boolean(
    rootElement
    && pathname === HOME_ROUTE
    && rootElement.getAttribute(PRERENDER_ROUTE_ATTRIBUTE) === HOME_ROUTE,
  );
}

function createApplicationElement() {
  return (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

function mountApplication({
  application = createApplicationElement(),
  createRootImpl = createRoot,
  hydrateRootImpl = hydrateRoot,
  pathname = readBrowserPathname(),
  rootElement,
} = {}) {
  if (!rootElement) {
    throw new Error('The application root element was not found.');
  }

  if (shouldHydratePrerenderedRoot(rootElement, pathname)) {
    return hydrateRootImpl(rootElement, application);
  }

  const root = createRootImpl(rootElement);
  root.render(application);
  return root;
}

export {
  HOME_ROUTE,
  PRERENDER_ROUTE_ATTRIBUTE,
  createApplicationElement,
  mountApplication,
  shouldHydratePrerenderedRoot,
};
